import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

import { type ConfirmationDialogProps } from "./confirmation-dialog.types";

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    open,
    title,
    message,
    onConfirm,
    onDismiss,
    confirmButtonText,
    cancelButtonText,
    label = "",
    ConfirmButtonIcon,
    CancelButtonIcon,
    hideConfirmation = false,
    ActionsComponent,
    dismissible = true,
    hideCancelButton,
    onOpenChange,
    className,
  } = props;
  const { t } = useTranslation();

  const showCloseButton =
    hideCancelButton !== undefined ? !hideCancelButton : dismissible;

  return (
    <Dialog open={open} onOpenChange={onOpenChange} data-test-id={label}>
      <DialogContent className={className} dismissible={dismissible}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <DialogDescription asChild>
          <div>{message}</div>
        </DialogDescription>

        <DialogFooter>
          {ActionsComponent && (
            <div className="mr-auto">{ActionsComponent}</div>
          )}

          {showCloseButton && (
            <Button
              data-test-id={`${label}-secondary-button`}
              data-testid={`${label}-secondary-button`}
              onClick={onDismiss}
              variant="ghost"
              type="button"
            >
              {CancelButtonIcon && CancelButtonIcon}
              {cancelButtonText || t("cancel")}
            </Button>
          )}

          {!hideConfirmation && (
            <Button
              data-test-id={`${label}-primary-button`}
              onClick={onConfirm}
              type="button"
            >
              {ConfirmButtonIcon && ConfirmButtonIcon}
              {confirmButtonText || t("ok")}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
